import React, { useLayoutEffect, useRef, useState } from "react";

export default function MediaPreviewImage({ src, alt, zoom, rotation, onError }) {
  const viewport = useRef();
  const [available, setAvailable] = useState({ width: 0, height: 0 });
  const [natural, setNatural] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const measure = () => {
      const { width, height } = viewport.current.getBoundingClientRect();
      setAvailable({ width, height });
    };
    measure();
    const observer = window.ResizeObserver ? new window.ResizeObserver(measure) : null;
    if (observer) observer.observe(viewport.current);
    window.addEventListener("resize", measure);
    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  const sideways = rotation % 180 !== 0;
  const rotatedWidth = sideways ? natural.height : natural.width;
  const rotatedHeight = sideways ? natural.width : natural.height;
  const fit = rotatedWidth && rotatedHeight ?
    Math.min(1, available.width / rotatedWidth, available.height / rotatedHeight) : 0;
  const width = natural.width * fit * zoom;
  const height = natural.height * fit * zoom;
  const boundsWidth = sideways ? height : width;
  const boundsHeight = sideways ? width : height;

  return (
    <div ref={viewport} style={{ width: "100%", height: "65vh", overflow: "auto", textAlign: "left" }}>
      {/* Reserve the full rotated bounds in normal layout, including at higher zoom. */}
      <div style={{ width: Math.max(available.width, boundsWidth),
        height: Math.max(available.height, boundsHeight), display: "flex",
        alignItems: "center", justifyContent: "center" }}>
        <div style={{ width: boundsWidth, height: boundsHeight, position: "relative",
          overflow: "hidden", flexShrink: 0 }}>
          <img src={src} alt={alt} onError={onError}
            onLoad={(event) => setNatural({ width: event.currentTarget.naturalWidth,
              height: event.currentTarget.naturalHeight })}
            style={{ width, height, maxWidth: "none", display: "block", position: "absolute",
              left: "50%", top: "50%", transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
              transformOrigin: "center" }} />
        </div>
      </div>
    </div>
  );
}
